<div class="kiktemp-loader">
    <img src="../../../../assets/media/icons/kikblox_logo_rounded.webp" alt="kiktemp-loader" class="spinners" />
    <div class="loading-text">Loading...</div>
  </div>
  